module.exports = __webpack_public_path__ + "static/img/demo_page_2.d86a877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_page_2.png
// module id = KqmB
// module chunks = 150